export default {
  usageTitle: {
    id: 'finder_usage_title',
    defaultMessage: 'What will you use it for?',
  },
  usageTooltip: {
    id: 'finder_usage_tooltip',
    defaultMessage:
      "We'll match your answer to the right specs, so you don't have to.",
  },
  usageOnTheGoLabel: {
    id: 'finder_usage_on_the_go_label',
    defaultMessage: 'On-the-go',
  },
  usageDailyUseLabel: {
    id: 'finder_usage_daily_use_label',
    defaultMessage: 'Daily use',
  },
  usageForCreativesLabel: {
    id: 'finder_usage_for_creatives_label',
    defaultMessage: 'For creatives',
  },
  usageForComplexWorkLabel: {
    id: 'finder_usage_for_complex_work_label',
    defaultMessage: 'For complex work',
  },
  budgetTitle: {
    id: 'finder_budget_title',
    defaultMessage: "What's your budget?",
  },
  requirementsTitle: {
    id: 'finder_requirements_title',
    defaultMessage: 'More requirements?',
  },
  sizeTitle: {
    id: 'finder_size_title',
    defaultMessage: 'What size do you want?',
  },
  conditionTitle: {
    id: 'finder_condition_title',
    defaultMessage: 'Which conditions?',
  },
  conditionTooltip: {
    id: 'finder_condition_tooltip',
    defaultMessage:
      'Every refurbished MacBook is tested and graded, so you always know what to expect.',
  },
  // Grade labels reuse the existing Lokalise keys from the reviews grade filter
  // (reviews_grade_filter_*).
  conditionFairLabel: {
    id: 'reviews_grade_filter_fair',
    defaultMessage: 'Fair',
  },
  conditionFairDescription: {
    id: 'finder_condition_fair_description',
    defaultMessage: 'Visible signs of wear, like scratches and scuffs.',
  },
  conditionGoodLabel: {
    id: 'reviews_grade_filter_good',
    defaultMessage: 'Good',
  },
  conditionGoodDescription: {
    id: 'finder_condition_good_description',
    defaultMessage: 'Light signs of wear, barely noticeable at arm’s length.',
  },
  conditionExcellentLabel: {
    id: 'reviews_grade_filter_excellent',
    defaultMessage: 'Excellent',
  },
  conditionExcellentDescription: {
    id: 'finder_condition_excellent_description',
    defaultMessage: 'Very light signs of wear, hard to notice.',
  },
  conditionPremiumLabel: {
    id: 'reviews_grade_filter_premium',
    defaultMessage: 'Premium',
  },
  conditionPremiumDescription: {
    id: 'finder_condition_premium_description',
    defaultMessage: 'Looks brand new, with no visible signs of wear.',
  },
  moreFiltersLabel: {
    id: 'finder_more_filters_label',
    defaultMessage: 'More filters',
  },
} as const
